define('viewmodels/modals/dialogs/ItunesTermsDialog',[],function () {

    function ItunesTermsDialog (dialog, termsPage) {
        this.dialog = dialog;
        this.terms = termsPage('terms');
        this.headline = termsPage('headline');
    }

    ItunesTermsDialog.prototype.show = function () {
        return this.dialog.showDialog(this);
    };

    ItunesTermsDialog.prototype.close = function () {
        this.dialog.close(this);
    };

    return ItunesTermsDialog;
});

